;(function () {
	'use strict';
	
	// init main navigation
	document.addEventListener("DOMContentLoaded", function(event) {
		var button = document.getElementById('DyslexiaToggleButton');
		if (typeof(button) != 'undefined' && button != null) {
			var toggle = new DyslexiaToggle(button);
		}
	});

	// Constructor
	function DyslexiaToggle (button) {
		
		this.button = button;
		
		// ready cookie
		var cookie = Cookies.get('dyslexia');
		if (typeof(cookie) != 'undefined' && cookie == 1) {
			this.activate();
		}

		// Handle button click
		this.button.addEventListener('click', function (e) {
			e.preventDefault();
			this.toggle();
		}.bind(this))

		// initiate listeners object for public events
		this._listeners = {}
	}
	
	// activate
	DyslexiaToggle.prototype.activate = function () {
		// activate switch
		this.button.setAttribute('aria-checked', true);
		// add class for css
		var html = document.getElementsByTagName( 'html' )[0];
		html.classList.add('dyslexia');
		// set cookie
		Cookies.set('dyslexia', 1);
		// fire event
		this._fire('activate');
		return this;
	}

	// Close methods
	DyslexiaToggle.prototype.deactivate = function () {
		// close nav
		this.button.setAttribute('aria-checked', false);
		// remove class for css
		var html = document.getElementsByTagName( 'html' )[0];
		html.classList.remove('dyslexia');
		// set cookie
		Cookies.set('dyslexia', 0);
		// fire event
		this._fire('deactivate');
		return this;
	}

	// Toggle methods
	DyslexiaToggle.prototype.toggle = function () {
		var expanded = this.button.getAttribute('aria-checked') === 'true';
		return expanded ? this.deactivate() : this.activate();
	}
	
	DyslexiaToggle.prototype._fire = function (type, data) {
		if (typeof this._listeners === 'undefined') {
			this._listeners = [];
		}
		var listeners = this._listeners[type] || [];

		listeners.forEach(function (listener) {
			listener(data);
		})
	}

	DyslexiaToggle.prototype.on = function (type, handler) {
		if (typeof this._listeners[type] === 'undefined') {
			this._listeners[type] = [];
		}

		this._listeners[type].push(handler);

		return this;
	}

	DyslexiaToggle.prototype.off = function (type, handler) {
		var index = this._listeners[type].indexOf(handler);

		if (index > -1) {
			this._listeners[type].splice(index, 1);
		}

		return this;
	}

	// Export DyslexiaToggle
	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
		module.exports = DyslexiaToggle;
	} else if (typeof define === 'function' && define.amd) {
		define('DyslexiaToggle', [], function () {
			return DyslexiaToggle;
		})
	} else {
		// attach to window
		window.DyslexiaToggle = DyslexiaToggle;
	}
}());
